module.exports = __webpack_public_path__ + "static/media/16․05.2ff5d9bd.jpg";